module.exports = __webpack_public_path__ + "static/media/NotoSansSC-Black-Alphabetic.cc9fe217.woff2";